import React from 'react'
import { connect } from 'react-redux'

import Link from '../helper/link'

import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { TidewaysContext } from '../app/context'
import { Entity } from '../app/entity'
import { DefaultOperation } from '../domain/Operation'
import { ApplicationState } from '../redux/ApplicationState'

interface MatchParams {
    operation: string
}

type StateProps = Entity<DefaultOperation | null> & { tidewaysContext: TidewaysContext }

type Props = StateProps & RouteComponentProps<MatchParams>

export class OperationComponent extends React.Component<Props> {
    public render = () => {
        const [transactionName, tagName, ...unknownRest] = this.props.data ? this.props.data.identifier.split('##') : ['']

        return (
            <ul className="nav navbar-nav">
                <li className="logo-nav">
                    <a href={'/dashboard?current=' + this.props.tidewaysContext.organization.name}>
                        <img src="/assets/img/tideways-small.png" alt="Dashboard" width="18" height="18" />
                    </a>
                </li>
                <li className="merged">
                    <Link route="dashboard" params={{ current: this.props.tidewaysContext.organization.name }}>
                        {this.props.tidewaysContext.organization.name}
                    </Link>{' '}
                    / <Link route="XhprofOrganizationBundle.Application.show">{this.props.tidewaysContext.application.name}</Link>
                </li>
                <li className="merged">
                    <Link route="XhprofOrganizationBundle.Application.show">Performance</Link> &gt;{' '}
                    <Link route="XhprofProfilerBundle.Transaction.show" params={{ operation: this.props.match.params.operation }}>
                        {this.props.data ? transactionName : ''}
                    </Link>
                </li>
            </ul>
        )
    }
}

export default withRouter(
    connect<StateProps>((globalState: ApplicationState, props: RouteComponentProps) => {
        const operation = globalState.operations.data[(props.match.params as any).operation] || new Entity()

        return {
            tidewaysContext: globalState.tidewaysContext,
            ...operation,
        }
    })(OperationComponent),
)
